import { getTenantId, getSession, logWorkspace, serviceState } from '../..';
import * as Telecom from '@servicetitan/telecom-rtcs-client';
import appManager from '@app/appManager';
import {
  ServiceSessionCreatedEvent,
  ServiceSessionEventType,
} from '../../types/ServiceEvents';

async function handleSessionCreated(event: Telecom.SessionCreatedEvent) {
  logWorkspace('service:session:created', event);

  const session = getSession(event.conversationId);
  if (session) {
    console.warn('session already exists', event.conversationId);
    return;
  }

  serviceState.sessions[event.conversationId] = {
    ...event,
    createdAt: Date.now(),
    tenantId: getTenantId(event.tenantId),
  };

  appManager.events.emit<ServiceSessionCreatedEvent>(
    ServiceSessionEventType.CREATED,
    {
      sessionId: event.conversationId,
      sessionSid: event.conversationSid,
      from: event.source.address,
      displayName: event.source.displayName ?? '',
      tenantId: getTenantId(event.tenantId),
    },
  );
}

export default handleSessionCreated;
